import { useMemo } from "react";

import { useGetPreShiftOrientations } from "./useGetPreShiftOrientations";

/**
 * Returns a map of workplace IDs to the original start time of the shift that
 * currently holds the pre-shift orientation designation at that workplace.
 *
 * Used to determine whether an open shift should show the orientation card.
 * An open shift should still show orientation if it starts earlier than the
 * existing designated shift, since the backend will transfer the designation.
 */
export function useWorkplacesWithUpcomingPreShiftOrientation(): {
  workplacesWithUpcomingPreShiftOrientation: Map<string, Date>;
  isLoading: boolean;
} {
  const { data, isLoading } = useGetPreShiftOrientations();

  const workplacesWithUpcomingPreShiftOrientation = useMemo(() => {
    const upcomingPreShiftOrientationMap = new Map<string, Date>();
    for (const preShiftOrientation of data?.data ?? []) {
      const workplaceId = preShiftOrientation.relationships.workplace.data.id;
      const originalStart = new Date(preShiftOrientation.attributes.originalStart);
      upcomingPreShiftOrientationMap.set(workplaceId, originalStart);
    }

    return upcomingPreShiftOrientationMap;
  }, [data?.data]);

  return {
    workplacesWithUpcomingPreShiftOrientation,
    isLoading,
  };
}
